import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {HTTP_406_NOT_ACCEPTABLE, HTTP_400_BAD_REQUEST} from '../../../common/httpStatusCodes';
import {Actions} from '../../../common/actions';

const focusField = (index, fieldId = '') => {
  const codeInput = document.getElementById(`${fieldId}${index}`);

  if (codeInput) {
    codeInput.focus();
  }
};

class PartCheckModal extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.handleRegisterClick = this.handleRegisterClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  handleRegisterClick() {
    const {invalidCode, invalidIndex, errorCode, selectedOrder, selectedValues} = this.props;

    if (errorCode === HTTP_406_NOT_ACCEPTABLE) {
      this.props.checkProviderStockOrderCode(selectedOrder, selectedValues, {'allowOtherProvider': true});
      this.props.changeSuggestedOrderInvalidCode('');
      setTimeout(() => focusField(invalidIndex, 'partQuantity'), 750);
      return;
    }

    if (window.location) {
      window.open(`${window.location.origin}/maestro-repuestos`, '_blank');
    }

    this.props.changePartsFormValue('incomingPart', invalidCode);
    this.props.changeSuggestedOrderInvalidCode('');
    setTimeout(() => focusField(invalidIndex, 'partCode'), 750);
  }

  handleCancelClick() {
    this.props.changeSuggestedOrderInvalidCode('');
    setTimeout(() => focusField(this.props.invalidIndex, 'partCode'), 500);
  }


  renderOkButton() {
    const {errorCode} = this.props;

    if (errorCode === HTTP_400_BAD_REQUEST) {
      return null;
    }

    const okButtonText = errorCode === HTTP_406_NOT_ACCEPTABLE ? 'PERMITIR' : 'ACTUALIZAR';

    return (
      <Button primary onClick={this.handleRegisterClick}>{okButtonText}</Button>
    );
  }

  render() {
    const {invalidCode, error} = this.props;

    return (
      <Modal
        open={!!invalidCode}
        trigger={<div />}
      >
        <Modal.Content>{error}</Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleCancelClick}>CANCELAR</Button>
          {this.renderOkButton()}
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'invalidCode': state.providerPartVerification.invalidCode,
    'invalidIndex': state.providerPartVerification.invalidIndex,
    'selectedOrder': state.providerPartVerification.selectedOrder,
    'selectedValues': state.providerPartVerification.selectedValues,
    'errorCode': state.providerPartVerification.errorCode,
    'error': state.providerPartVerification.errorDescription,
  };
};

const {
  changePartsFormValue,
  updateInvalidPartCode,
  checkProviderStockOrderCode,
  changeSuggestedOrderInvalidCode,
} = Actions;

export default connect(mapStateToProps, {
  changePartsFormValue,
  updateInvalidPartCode,
  checkProviderStockOrderCode,
  changeSuggestedOrderInvalidCode,
})(PartCheckModal);
